import React from 'react';
import ReactDOM from 'react-dom';
import DialogErrorMessage from '../components/DialogErrorMessage';

// Tratamento de erros
export const errorHandling = response => {

  // Trata erros referentes a validação de dados enviados na requisição
  if (response !== undefined && response.status === 422 && response.data.code === 'ERROR_INPUT_DATA') {
    let message = response.data.message;

    if (response.data.error && response.data.error.length) {
      const messages = response.data.error.map(e => e.msg);
      message = [message + ':', ...new Set(messages)];
    }

    showDialogErrorMessage(message);
  }
};

// Adiciona/exibe diálogo de erro
export const showDialogErrorMessage = message => {
  const dialog = React.createElement(DialogErrorMessage, { message });
  const at = document.getElementById('global-dynamic-content');
  ReactDOM.render(dialog, at);
};
